export default "__VITE_ASSET__a8efac24__"